import { IcoArrowLeft } from "assets/icons";
import { ApplicationListFilters } from "components/BackofficeApplicationListFilterForm";
import Button from "components/Button";
import LocalStorageHelper from "helpers/LocalStorageHelper";
import {
	useCurrentUser,
	useCurrentUserDispatch
} from "providers/CurrentUserProvider";
import { useMemo } from "react";
import { useMediaQuery } from "react-responsive";
import { Link, useLocation } from "react-router-dom";
import { ApplicationService } from "services/applicationService";
import { AuthService } from "services/auth";
import { Account, SideMenu } from "./modules";
import BackofficeNavigation from "./modules/BackofficeNavigation";

const emptyFilters: ApplicationListFilters = {
	statuses: [],
	interventionTypes: [],
	concessionaires: [],
	responsibleGroups: [],
	analysts: [],
	projectProgressStatus: "",
	regulatoryAgencies: []
};

export default function LoggedInHeader({
	baseUrl,
	isExternalUser
}: Readonly<{
	baseUrl: string;
	isExternalUser: boolean;
}>) {
	const authService = useMemo(() => AuthService.getInstance(), []);
	const location = useLocation();
	const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

	const user = useCurrentUser();
	const dispatch = useCurrentUserDispatch();

	const filters =
		LocalStorageHelper.useLocalStorageState<ApplicationListFilters>(
			LocalStorageHelper.backofficeListFiltersKey
		)[0] ?? emptyFilters;

	const formattedFilters = new URLSearchParams(
		ApplicationService.makeBackofficeApplicationFilterParams(filters)
	).toString();

	const pathSlugs = location.pathname.split("/");
	const isBackoffice = pathSlugs.find((p) => p === "backoffice");

	return (
		<header className="border-b border-neutral-high-100 relative bg-neutral-high-pure-50 w-full h-14 sm:h-16">
			<div className="flex flex-row h-14 sm:h-16 max-sm:py-2 justify-center items-center mx-4 md:mx-6">
				<div className="flex flex-row items-center justify-start absolute left-0 ml-4 md:ml-6">
					<Link
						reloadDocument
						to={isBackoffice ? `${baseUrl}?${formattedFilters}` : baseUrl}
						className="font-semibold text-base sm:text-lg max-sm:mr-8 cursor-pointer"
					>
						{window.location.pathname === baseUrl || !isMobile ? (
							<p>Faixa de Domínio</p>
						) : (
							<IcoArrowLeft size="24" />
						)}
					</Link>
				</div>
				{isBackoffice && <BackofficeNavigation />}
				<div className="h-min hover:h-[10rem] flex flex-row items-center justify-end absolute right-0 mr-4 md:mr-6">
					{user ? (
						<>
							<Account />
							<SideMenu baseUrl={baseUrl} isExternalUser={isExternalUser} />
						</>
					) : (
						<Button
							kind="link"
							hierarchy="ghost"
							size="small"
							onClick={async () => authService.logout(dispatch)}
						>
							Sair
						</Button>
					)}
				</div>
			</div>
		</header>
	);
}
